"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrpcWebImpl = exports.MsgEditTableDesc = exports.MsgRenewalDatasetDesc = exports.MsgEditDatasetDesc = exports.MsgCreateDatasetDesc = exports.MsgDesc = exports.MsgClientImpl = exports.RenewalDatasetResponse = exports.RenewalDatasetRequest = exports.EditDatasetResponse = exports.EditDatasetRequest = exports.CreateDatasetResponse = exports.CreateDatasetRequest = exports.EditTableResponse = exports.EditTableRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const grpc_web_1 = require("@improbable-eng/grpc-web");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const dataset_1 = require("../../glitterchain/index/dataset");
const browser_headers_1 = require("browser-headers");
const timestamp_1 = require("../../google/protobuf/timestamp");
exports.protobufPackage = "glitterchain.index";
const baseEditTableRequest = { fromAddress: "", datasetName: "", tableName: "", meta: "" };
exports.EditTableRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.fromAddress !== "") {
            writer.uint32(10).string(message.fromAddress);
        }
        if (message.datasetName !== "") {
            writer.uint32(18).string(message.datasetName);
        }
        if (message.tableName !== "") {
            writer.uint32(26).string(message.tableName);
        }
        if (message.meta !== "") {
            writer.uint32(34).string(message.meta);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseEditTableRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.datasetName = reader.string();
                    break;
                case 3:
                    message.tableName = reader.string();
                    break;
                case 4:
                    message.meta = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseEditTableRequest);
        if (object.fromAddress !== undefined && object.fromAddress !== null) {
            message.fromAddress = String(object.fromAddress);
        }
        else {
            message.fromAddress = "";
        }
        if (object.datasetName !== undefined && object.datasetName !== null) {
            message.datasetName = String(object.datasetName);
        }
        else {
            message.datasetName = "";
        }
        if (object.tableName !== undefined && object.tableName !== null) {
            message.tableName = String(object.tableName);
        }
        else {
            message.tableName = "";
        }
        if (object.meta !== undefined && object.meta !== null) {
            message.meta = String(object.meta);
        }
        else {
            message.meta = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.datasetName !== undefined && (obj.datasetName = message.datasetName);
        message.tableName !== undefined && (obj.tableName = message.tableName);
        message.meta !== undefined && (obj.meta = message.meta);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseEditTableRequest);
        if (object.fromAddress !== undefined && object.fromAddress !== null) {
            message.fromAddress = object.fromAddress;
        }
        else {
            message.fromAddress = "";
        }
        if (object.datasetName !== undefined && object.datasetName !== null) {
            message.datasetName = object.datasetName;
        }
        else {
            message.datasetName = "";
        }
        if (object.tableName !== undefined && object.tableName !== null) {
            message.tableName = object.tableName;
        }
        else {
            message.tableName = "";
        }
        if (object.meta !== undefined && object.meta !== null) {
            message.meta = object.meta;
        }
        else {
            message.meta = "";
        }
        return message;
    },
};
const baseEditTableResponse = {};
exports.EditTableResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseEditTableResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseEditTableResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseEditTableResponse);
        return message;
    },
};
const baseCreateDatasetRequest = {
    fromAddress: "",
    datasetName: "",
    workStatus: 0,
    hosts: "",
    manageAddresses: "",
    meta: "",
    description: "",
    duration: long_1.default.ZERO,
};
exports.CreateDatasetRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.fromAddress !== "") {
            writer.uint32(10).string(message.fromAddress);
        }
        if (message.datasetName !== "") {
            writer.uint32(18).string(message.datasetName);
        }
        if (message.workStatus !== 0) {
            writer.uint32(24).int32(message.workStatus);
        }
        if (message.hosts !== "") {
            writer.uint32(34).string(message.hosts);
        }
        if (message.manageAddresses !== "") {
            writer.uint32(42).string(message.manageAddresses);
        }
        if (message.meta !== "") {
            writer.uint32(50).string(message.meta);
        }
        if (message.description !== "") {
            writer.uint32(58).string(message.description);
        }
        if (!message.duration.isZero()) {
            writer.uint32(64).int64(message.duration);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseCreateDatasetRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.datasetName = reader.string();
                    break;
                case 3:
                    message.workStatus = reader.int32();
                    break;
                case 4:
                    message.hosts = reader.string();
                    break;
                case 5:
                    message.manageAddresses = reader.string();
                    break;
                case 6:
                    message.meta = reader.string();
                    break;
                case 7:
                    message.description = reader.string();
                    break;
                case 8:
                    message.duration = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseCreateDatasetRequest);
        if (object.fromAddress !== undefined && object.fromAddress !== null) {
            message.fromAddress = String(object.fromAddress);
        }
        else {
            message.fromAddress = "";
        }
        if (object.datasetName !== undefined && object.datasetName !== null) {
            message.datasetName = String(object.datasetName);
        }
        else {
            message.datasetName = "";
        }
        if (object.workStatus !== undefined && object.workStatus !== null) {
            message.workStatus = dataset_1.serviceStatusFromJSON(object.workStatus);
        }
        else {
            message.workStatus = 0;
        }
        if (object.hosts !== undefined && object.hosts !== null) {
            message.hosts = String(object.hosts);
        }
        else {
            message.hosts = "";
        }
        if (object.manageAddresses !== undefined && object.manageAddresses !== null) {
            message.manageAddresses = String(object.manageAddresses);
        }
        else {
            message.manageAddresses = "";
        }
        if (object.meta !== undefined && object.meta !== null) {
            message.meta = String(object.meta);
        }
        else {
            message.meta = "";
        }
        if (object.description !== undefined && object.description !== null) {
            message.description = String(object.description);
        }
        else {
            message.description = "";
        }
        if (object.duration !== undefined && object.duration !== null) {
            message.duration = long_1.default.fromString(object.duration);
        }
        else {
            message.duration = long_1.default.ZERO;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.datasetName !== undefined && (obj.datasetName = message.datasetName);
        message.workStatus !== undefined && (obj.workStatus = dataset_1.serviceStatusToJSON(message.workStatus));
        message.hosts !== undefined && (obj.hosts = message.hosts);
        message.manageAddresses !== undefined && (obj.manageAddresses = message.manageAddresses);
        message.meta !== undefined && (obj.meta = message.meta);
        message.description !== undefined && (obj.description = message.description);
        message.duration !== undefined && (obj.duration = (message.duration || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseCreateDatasetRequest);
        if (object.fromAddress !== undefined && object.fromAddress !== null) {
            message.fromAddress = object.fromAddress;
        }
        else {
            message.fromAddress = "";
        }
        if (object.datasetName !== undefined && object.datasetName !== null) {
            message.datasetName = object.datasetName;
        }
        else {
            message.datasetName = "";
        }
        if (object.workStatus !== undefined && object.workStatus !== null) {
            message.workStatus = object.workStatus;
        }
        else {
            message.workStatus = 0;
        }
        if (object.hosts !== undefined && object.hosts !== null) {
            message.hosts = object.hosts;
        }
        else {
            message.hosts = "";
        }
        if (object.manageAddresses !== undefined && object.manageAddresses !== null) {
            message.manageAddresses = object.manageAddresses;
        }
        else {
            message.manageAddresses = "";
        }
        if (object.meta !== undefined && object.meta !== null) {
            message.meta = object.meta;
        }
        else {
            message.meta = "";
        }
        if (object.description !== undefined && object.description !== null) {
            message.description = object.description;
        }
        else {
            message.description = "";
        }
        if (object.duration !== undefined && object.duration !== null) {
            message.duration = object.duration;
        }
        else {
            message.duration = long_1.default.ZERO;
        }
        return message;
    },
};
const baseCreateDatasetResponse = {};
exports.CreateDatasetResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.expirationTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.expirationTime), writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseCreateDatasetResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.expirationTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseCreateDatasetResponse);
        if (object.expirationTime !== undefined && object.expirationTime !== null) {
            message.expirationTime = fromJsonTimestamp(object.expirationTime);
        }
        else {
            message.expirationTime = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.expirationTime !== undefined && (obj.expirationTime = message.expirationTime.toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseCreateDatasetResponse);
        if (object.expirationTime !== undefined && object.expirationTime !== null) {
            message.expirationTime = object.expirationTime;
        }
        else {
            message.expirationTime = undefined;
        }
        return message;
    },
};
const baseEditDatasetRequest = {
    fromAddress: "",
    datasetName: "",
    workStatus: 0,
    hosts: "",
    manageAddresses: "",
    meta: "",
    description: "",
};
exports.EditDatasetRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.fromAddress !== "") {
            writer.uint32(10).string(message.fromAddress);
        }
        if (message.datasetName !== "") {
            writer.uint32(18).string(message.datasetName);
        }
        if (message.workStatus !== 0) {
            writer.uint32(24).int32(message.workStatus);
        }
        if (message.hosts !== "") {
            writer.uint32(34).string(message.hosts);
        }
        if (message.manageAddresses !== "") {
            writer.uint32(42).string(message.manageAddresses);
        }
        if (message.meta !== "") {
            writer.uint32(50).string(message.meta);
        }
        if (message.description !== "") {
            writer.uint32(58).string(message.description);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseEditDatasetRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.datasetName = reader.string();
                    break;
                case 3:
                    message.workStatus = reader.int32();
                    break;
                case 4:
                    message.hosts = reader.string();
                    break;
                case 5:
                    message.manageAddresses = reader.string();
                    break;
                case 6:
                    message.meta = reader.string();
                    break;
                case 7:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseEditDatasetRequest);
        if (object.fromAddress !== undefined && object.fromAddress !== null) {
            message.fromAddress = String(object.fromAddress);
        }
        else {
            message.fromAddress = "";
        }
        if (object.datasetName !== undefined && object.datasetName !== null) {
            message.datasetName = String(object.datasetName);
        }
        else {
            message.datasetName = "";
        }
        if (object.workStatus !== undefined && object.workStatus !== null) {
            message.workStatus = dataset_1.serviceStatusFromJSON(object.workStatus);
        }
        else {
            message.workStatus = 0;
        }
        if (object.hosts !== undefined && object.hosts !== null) {
            message.hosts = String(object.hosts);
        }
        else {
            message.hosts = "";
        }
        if (object.manageAddresses !== undefined && object.manageAddresses !== null) {
            message.manageAddresses = String(object.manageAddresses);
        }
        else {
            message.manageAddresses = "";
        }
        if (object.meta !== undefined && object.meta !== null) {
            message.meta = String(object.meta);
        }
        else {
            message.meta = "";
        }
        if (object.description !== undefined && object.description !== null) {
            message.description = String(object.description);
        }
        else {
            message.description = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.datasetName !== undefined && (obj.datasetName = message.datasetName);
        message.workStatus !== undefined && (obj.workStatus = dataset_1.serviceStatusToJSON(message.workStatus));
        message.hosts !== undefined && (obj.hosts = message.hosts);
        message.manageAddresses !== undefined && (obj.manageAddresses = message.manageAddresses);
        message.meta !== undefined && (obj.meta = message.meta);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseEditDatasetRequest);
        if (object.fromAddress !== undefined && object.fromAddress !== null) {
            message.fromAddress = object.fromAddress;
        }
        else {
            message.fromAddress = "";
        }
        if (object.datasetName !== undefined && object.datasetName !== null) {
            message.datasetName = object.datasetName;
        }
        else {
            message.datasetName = "";
        }
        if (object.workStatus !== undefined && object.workStatus !== null) {
            message.workStatus = object.workStatus;
        }
        else {
            message.workStatus = 0;
        }
        if (object.hosts !== undefined && object.hosts !== null) {
            message.hosts = object.hosts;
        }
        else {
            message.hosts = "";
        }
        if (object.manageAddresses !== undefined && object.manageAddresses !== null) {
            message.manageAddresses = object.manageAddresses;
        }
        else {
            message.manageAddresses = "";
        }
        if (object.meta !== undefined && object.meta !== null) {
            message.meta = object.meta;
        }
        else {
            message.meta = "";
        }
        if (object.description !== undefined && object.description !== null) {
            message.description = object.description;
        }
        else {
            message.description = "";
        }
        return message;
    },
};
const baseEditDatasetResponse = {};
exports.EditDatasetResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseEditDatasetResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseEditDatasetResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseEditDatasetResponse);
        return message;
    },
};
const baseRenewalDatasetRequest = { fromAddress: "", datasetName: "", duration: long_1.default.ZERO };
exports.RenewalDatasetRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.fromAddress !== "") {
            writer.uint32(10).string(message.fromAddress);
        }
        if (message.datasetName !== "") {
            writer.uint32(18).string(message.datasetName);
        }
        if (!message.duration.isZero()) {
            writer.uint32(24).int64(message.duration);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRenewalDatasetRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.datasetName = reader.string();
                    break;
                case 3:
                    message.duration = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseRenewalDatasetRequest);
        if (object.fromAddress !== undefined && object.fromAddress !== null) {
            message.fromAddress = String(object.fromAddress);
        }
        else {
            message.fromAddress = "";
        }
        if (object.datasetName !== undefined && object.datasetName !== null) {
            message.datasetName = String(object.datasetName);
        }
        else {
            message.datasetName = "";
        }
        if (object.duration !== undefined && object.duration !== null) {
            message.duration = long_1.default.fromString(object.duration);
        }
        else {
            message.duration = long_1.default.ZERO;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.datasetName !== undefined && (obj.datasetName = message.datasetName);
        message.duration !== undefined && (obj.duration = (message.duration || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseRenewalDatasetRequest);
        if (object.fromAddress !== undefined && object.fromAddress !== null) {
            message.fromAddress = object.fromAddress;
        }
        else {
            message.fromAddress = "";
        }
        if (object.datasetName !== undefined && object.datasetName !== null) {
            message.datasetName = object.datasetName;
        }
        else {
            message.datasetName = "";
        }
        if (object.duration !== undefined && object.duration !== null) {
            message.duration = object.duration;
        }
        else {
            message.duration = long_1.default.ZERO;
        }
        return message;
    },
};
const baseRenewalDatasetResponse = {};
exports.RenewalDatasetResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.expirationTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.expirationTime), writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRenewalDatasetResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.expirationTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseRenewalDatasetResponse);
        if (object.expirationTime !== undefined && object.expirationTime !== null) {
            message.expirationTime = fromJsonTimestamp(object.expirationTime);
        }
        else {
            message.expirationTime = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.expirationTime !== undefined && (obj.expirationTime = message.expirationTime.toISOString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseRenewalDatasetResponse);
        if (object.expirationTime !== undefined && object.expirationTime !== null) {
            message.expirationTime = object.expirationTime;
        }
        else {
            message.expirationTime = undefined;
        }
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.CreateDataset = this.CreateDataset.bind(this);
        this.EditDataset = this.EditDataset.bind(this);
        this.RenewalDataset = this.RenewalDataset.bind(this);
        this.EditTable = this.EditTable.bind(this);
    }
    CreateDataset(request, metadata) {
        return this.rpc.unary(exports.MsgCreateDatasetDesc, exports.CreateDatasetRequest.fromPartial(request), metadata);
    }
    EditDataset(request, metadata) {
        return this.rpc.unary(exports.MsgEditDatasetDesc, exports.EditDatasetRequest.fromPartial(request), metadata);
    }
    RenewalDataset(request, metadata) {
        return this.rpc.unary(exports.MsgRenewalDatasetDesc, exports.RenewalDatasetRequest.fromPartial(request), metadata);
    }
    EditTable(request, metadata) {
        return this.rpc.unary(exports.MsgEditTableDesc, exports.EditTableRequest.fromPartial(request), metadata);
    }
}
exports.MsgClientImpl = MsgClientImpl;
exports.MsgDesc = {
    serviceName: "glitterchain.index.Msg",
};
exports.MsgCreateDatasetDesc = {
    methodName: "CreateDataset",
    service: exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.CreateDatasetRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.CreateDatasetResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
exports.MsgEditDatasetDesc = {
    methodName: "EditDataset",
    service: exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.EditDatasetRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.EditDatasetResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
exports.MsgRenewalDatasetDesc = {
    methodName: "RenewalDataset",
    service: exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.RenewalDatasetRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.RenewalDatasetResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
exports.MsgEditTableDesc = {
    methodName: "EditTable",
    service: exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.EditTableRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exports.EditTableResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
    },
};
class GrpcWebImpl {
    constructor(host, options) {
        this.host = host;
        this.options = options;
    }
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata
            ? new browser_headers_1.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap))
            : metadata || this.options.metadata;
        return new Promise((resolve, reject) => {
            grpc_web_1.grpc.unary(methodDesc, {
                request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function (response) {
                    if (response.status === grpc_web_1.grpc.Code.OK) {
                        resolve(response.message);
                    }
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                },
            });
        });
    }
}
exports.GrpcWebImpl = GrpcWebImpl;
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=tx.js.map